"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowModel = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const validation_1 = require("../validation");
const eventargs_1 = require("../eventargs");
const core_1 = require("@integro/core");
const log = (0, debug_1.default)('itp:ui:components:datatable:row');
class RowModel {
    isRow;
    $$table;
    $$oldValue;
    $$editingRowBackup;
    $$editing;
    $$isExpanded;
    $$isSelected;
    $$keys;
    $$editorStatus;
    $$history;
    validationState;
    constructor(owner, data) {
        this.isRow = true;
        this.$$table = owner;
        this.$$editing = false;
        this.$$isExpanded = false;
        this.$$isSelected = false;
        this.setData(data);
    }
    setData(data) {
        this.$$oldValue = (0, core_1.deepCopy)(data);
        this.$$keys = _.keys(data);
        _.extend(this, data);
    }
    getData() {
        return _.pick(this, this.$$keys);
    }
    get rowKey() {
        return this.getValue(this.$$table.rowKeyField);
    }
    get isEditable() {
        return this.$$table.isRowEditable(this);
    }
    get isDeletable() {
        return this.$$table.isRowDeletable(this);
    }
    get isEditing() {
        return this.$$editing;
    }
    get isExpanded() {
        return this.$$isExpanded;
    }
    get isSaving() {
        return this.$$editorStatus === 'save';
    }
    get isDeleting() {
        return this.$$editorStatus === 'delete';
    }
    get isNew() {
        return this.$$table.getRowKey(this) == null;
    }
    get oldValue() {
        return this.$$oldValue;
    }
    get editingRowStatus() {
        return this.$$editorStatus;
    }
    onSelectionChanged() {
        this.$$table.eventBus.$emit('rowSelectionChanged', {
            row: this.rowKey,
            selected: this.$$isSelected
        });
    }
    get selected() {
        return this.$$isSelected;
    }
    setFocus(fieldName) {
        this.$$table.eventBus.$emit('focusCell', {
            row: this.rowKey,
            fieldName
        });
    }
    getValue(fieldName) {
        return _.get(this, fieldName);
    }
    setValue(fieldName, value) {
        _.set(this, fieldName, value);
        if (this.validationState) {
            this.validationState.validateField(fieldName, value);
        }
    }
    setValues(values) {
        _.each(values, (v, k) => this.setValue(k, v));
    }
    toggleExpanded() {
        this.$$isExpanded = !this.$$isExpanded;
    }
    beginEdit() {
        this.validationState = new validation_1.RowValidationState(this, this.$$table.options.columns);
        this.$$editing = true;
        this.$$editingRowBackup = (0, core_1.deepCopy)(this.getData());
        log('beginEdit %o, vs: %o', this, this.validationState);
    }
    endEdit(cancel = false) {
        log('endEdit (cancel=%s) %o', cancel, this);
        const self = this;
        return new Promise((resolve, reject) => {
            log('endEdit promise called...(cancel=%s)', cancel);
            if (cancel) {
                log('calling reset...');
                self.$$_reset();
                return resolve(true);
            }
            if (!this.validationState) {
                console.warn('[editor error] Missing validationState object!');
                return resolve(true);
            }
            this.validationState.validate().then(vs => {
                if (vs.invalid) {
                    return resolve(false);
                }
                this.$$editorStatus = 'save';
                const dt = this.$$table.component;
                const args = new eventargs_1.SaveEventArgs(this.getData(), dt);
                try {
                    dt.callListeners('save', args);
                }
                catch {
                    log('calling listeners failed');
                    this.$$editorStatus = null;
                    resolve(false);
                    return;
                }
                args
                    .whenReady()
                    .then(result => {
                    log('apply: ready. result=%o', result);
                    if (_.isObject(result)) {
                        this.$$_commit(result);
                    }
                    else {
                        this.$$_commit();
                    }
                    resolve(true);
                    dt.callListeners('save-completed', {
                        args,
                        result: result || this.getData()
                    });
                })
                    .catch(error => {
                    resolve(false);
                    this.$$editorStatus = null;
                    dt.$imodal.error({ error });
                    dt.callListeners('save-failed', { args, error });
                });
            });
        });
    }
    delete() {
        if (this.isEditing) {
            return;
        }
        log('delete %o', this);
        this.$$_promptUserBeforeDeleteRow().then(ok => {
            if (!ok) {
                return;
            }
            this.$$editorStatus = 'delete';
            const dt = this.$$table.component;
            const args = new eventargs_1.DeleteEventArgs(this.getData(), dt);
            dt.callListeners('delete', args);
            args
                .whenReady()
                .then(result => {
                if (result === false) {
                    return;
                }
                this.$$table.removeRow(this);
                dt.callListeners('delete-completed', { args });
            })
                .catch(error => {
                this.$$editorStatus = null;
                dt.$imodal.error({ error });
                dt.callListeners('delete-failed', { args, error });
            })
                .finally(() => {
                this.$$editorStatus = null;
            });
        });
    }
    $$_promptUserBeforeDeleteRow() {
        if (this.$$table.options.noConfirmDeleteRow) {
            return Promise.resolve(true);
        }
        const dt = this.$$table.component, messages = this.$$table.messages;
        return dt.$imodal.confirm({
            message: messages.msgConfirmDeleteRow,
            header: messages.msgConfirmDeleteRowHeader,
            btnOk: messages.msgConfirmDeleteRowBtnOK
        });
    }
    $$_commit(result = null) {
        if (!this.$$history) {
            this.$$history = [];
        }
        if (result) {
            this.setData(result);
            this.$$history.push(result);
        }
        else {
            this.$$history.push(this.getData());
        }
        this.validationState = null;
        this.$$editingRowBackup = null;
        this.$$editing = false;
    }
    $$_reset(newData = null) {
        log('%o reset in progress... newData=%o', this, newData);
        if (newData) {
            log('reset %o with newData=%o', this, newData);
            this.setData(newData);
        }
        else if (this.$$editingRowBackup) {
            log('reset %o with row backup=%o', this, this.$$editingRowBackup);
            this.setData(this.$$editingRowBackup);
        }
        this.validationState = null;
        this.$$editingRowBackup = null;
        this.$$editing = false;
        log('%o has been reset', this);
    }
}
exports.RowModel = RowModel;
//# sourceMappingURL=row-model.js.map